import { render, staticRenderFns } from "./ProductSimpleTable.vue?vue&type=template&id=1f828f60&"
import script from "./ProductSimpleTable.vue?vue&type=script&lang=js&"
export * from "./ProductSimpleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VPagination,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f828f60')) {
      api.createRecord('1f828f60', component.options)
    } else {
      api.reload('1f828f60', component.options)
    }
    module.hot.accept("./ProductSimpleTable.vue?vue&type=template&id=1f828f60&", function () {
      api.rerender('1f828f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Warehouse/components/Product/ProductSimpleTable.vue"
export default component.exports